import { render, staticRenderFns } from "./proceed_detail.vue?vue&type=template&id=b98cc990&scoped=true&"
import script from "./proceed_detail.vue?vue&type=script&lang=js&"
export * from "./proceed_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98cc990",
  null
  
)

export default component.exports